<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- SECCIÓN SUPERIOR: Gráficos (círculo, muñeca, moño) -->
        <div class="top-graphics-wrapper">
          <img
            ref="circuloRef"
            src="@/assets/circuuu.png"
            alt="Círculo de Rosas"
            class="circulo-img"
          >

          <!-- ✦ CAPA DE POLVO MÁGICO / ESTRELLITAS (OPTIMIZADA) -->
          <div class="polvo-magico-container" aria-hidden="true">
            <span class="polvo p1">✦</span>
            <span class="polvo p2">✧</span>
            <span class="polvo p3">✦</span>
            <span class="polvo p4">✧</span>
            <span class="polvo p5">✦</span>
            <span class="polvo p6">✧</span>
            <span class="polvo p7">✦</span>
            <span class="polvo p8">✧</span>
            <span class="polvo p9">✦</span>
            <span class="polvo p10">✧</span>
            <span class="polvo p11">✦</span>
            <span class="polvo p12">✧</span>
            <span class="polvo p13">✦</span>
            <span class="polvo p14">✧</span>
            <span class="polvo p15">✦</span>
            <span class="polvo p16">✧</span>
            <span class="polvo p17">✦</span>
            <span class="polvo p18">✧</span>
          </div>

          <img
            ref="quinceaneraRef"
            src="@/assets/quincee.png"
            alt="Quinceañera"
            class="quinceanera-img"
          >
          <img
            ref="monoRef"
            src="@/assets/monio2.png"
            alt="Moño Rojo"
            class="mono-img"
          >
        </div>

        <!-- SECCIÓN CENTRAL: Nombres y Texto -->
        <div class="centered-content">
          <div ref="letsHonorRef" class="lets-honor-text">ES UN HONOR INVITARTE A LA  </div>
          <div ref="quinceaneraTitleRef" class="quinceanera-title">QUINCEAÑERA DE</div>
          <div ref="nombreRef" class="nombre-principal">
            <span class="i-corinthia">G</span>racie <br> Talavera
          </div>
        </div>

        <!-- 🎭 MÁSCARA ESTÁTICA EN EL LADO IZQUIERDO -->
        <div class="mascara-left-container">
          <img 
            ref="mascaraRef" 
            src="@/assets/coronaa.png" 
            alt="Máscara Antifaz" 
            class="mascara-img-left"
          >
        </div>

        <!-- 🦋 CONTENEDOR DE MARIPOSAS -->
        <div class="butterflies-container">
          <img 
            ref="mariposa1Ref" 
            :src="mariposaImg" 
            alt="Mariposa 1" 
            class="mariposa-img vuelo-suave"
          >
          <img 
            ref="mariposa2Ref" 
            :src="mariposaImg" 
            alt="Mariposa 2" 
            class="mariposa-img vuelo-suave"
          >
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

// Importar la imagen explícitamente
import mariposaImg from '@/assets/elemento2.png'

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    // Referencias HTML
    const fotoPortadaRef = ref(null)
    const circuloRef = ref(null)
    const quinceaneraRef = ref(null)
    const monoRef = ref(null)
    const letsHonorRef = ref(null)
    const quinceaneraTitleRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const btnMapsRef = ref(null)
    const mascaraRef = ref(null)
    
    // Referencias directas a las mariposas
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    onMounted(() => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      // ---------------------------------------------------------
      // 0. ESTADO INICIAL: MÁSCARA FIJA EN IZQUIERDA SIN MOVIMIENTO
      // ---------------------------------------------------------
      gsap.set(mascaraRef.value, { 
        opacity: 0
      });

      gsap.set(mariposa1Ref.value, { 
        x: w + 200, 
        y: h * 0.8, 
        opacity: 0, 
        scale: 0.7, 
        rotation: -20
      });

      gsap.set(mariposa2Ref.value, { 
        x: -200, 
        y: h * 0.9, 
        opacity: 0, 
        scale: 0.8, 
        rotation: 20
      });

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA PRINCIPAL
      // ---------------------------------------------------------
      gsap.from(fotoPortadaRef.value, { opacity: 0, y: 80, duration: 1.4, ease: 'power3.out' })
      const tl = gsap.timeline({ delay: 0.8 });
      tl.fromTo(circuloRef.value, { opacity: 0, y: -150, scale: 1.8, filter: 'blur(15px)' }, { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.8, ease: 'power4.out' }, 0);
      tl.from(quinceaneraRef.value, { opacity: 0, y: 50, duration: 1.5, ease: 'power3.out' }, 0.8);
      tl.from(monoRef.value, { opacity: 0, scale: 0, duration: 1.2, ease: 'back.out(1.8)' }, 1.2);
      tl.from([letsHonorRef.value, quinceaneraTitleRef.value], { opacity: 0, y: 30, duration: 1, stagger: 0.2, ease: 'power2.out' }, "-=0.5");
      tl.from(nombreRef.value, { opacity: 0, y: 40, duration: 1.4, ease: 'back.out(1.7)' }, "-=0.3");
      tl.from(fechaRef.value, { opacity: 0, scale: 0.9, duration: 1, ease: 'power3.out' }, "+=0.1");
      tl.from(btnMapsRef.value, { opacity: 0, scale: 0, duration: 0.8, ease: 'back.out(2)' }, "+=0.3");

      // ---------------------------------------------------------
      // 🦋 2. ANIMACIÓN DE MARIPOSA Y APARICIÓN ESTÁTICA DE MÁSCARA
      // ---------------------------------------------------------
      const tlFlight = gsap.timeline({ repeat: -1 });

      // La máscara simplemente se hace visible de golpe/fade en su posición fija izquierda
      tlFlight.to(mascaraRef.value, {
        duration: 1,
        opacity: 1,
        ease: "power1.inOut"
      }, 0);

      // Animación de vuelo normal solo para la Mariposa 1 al mismo tiempo
      tlFlight.to(mariposa1Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 0)
      .to(mariposa1Ref.value, {
        duration: 5,
        x: -200,
        y: h * 0.1,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa1Ref.value, {
        x: w + 200,
        y: h * 0.8,
        opacity: 0,
        scale: 0.7,
        rotation: -20
      });

      // --- Mariposa 2 ---
      tlFlight.to(mariposa2Ref.value, {
        duration: 5,
        x: w * 0.5,
        y: h * 0.5,
        opacity: 1,
        ease: "sine.inOut"
      }, 5)
      .to(mariposa2Ref.value, {
        duration: 5,
        x: w + 200,
        y: h * 0.2,
        opacity: 0,
        ease: "sine.inOut"
      })
      .set(mariposa2Ref.value, {
        x: -200,
        y: h * 0.9,
        opacity: 0,
        scale: 0.8,
        rotation: 20
      });
    })

    return {
      fotoPortadaRef, circuloRef, quinceaneraRef, monoRef, letsHonorRef,
      quinceaneraTitleRef, nombreRef, fechaRef, btnMapsRef, mascaraRef,
      mariposa1Ref, mariposa2Ref,
      mariposaImg
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: auto;
  background-color: #fff;
  z-index: 1;
}

.overlay {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 30px;
  padding-bottom: 20px;
  z-index: 2;
  box-sizing: border-box;
}

/* ==========================================
   2. GRÁFICOS SUPERIORES Y POLVO MÁGICO
   ========================================== */
.top-graphics-wrapper {
  position: relative;
  width: 90vw;
  max-width: 480px;
  display: flex;
  margin-top: 80px;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.circulo-img {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
}

/* ✦ CAPA DE ESTRELLITAS Y POLVO MÁGICO BAJO EL CÍRCULO */
.polvo-magico-container {
  position: absolute;
  top: 40%;
  left: -5%;
  width: 110%;
  height: 65%;
  pointer-events: none;
  z-index: 2;
  overflow: hidden;
}

.polvo {
  position: absolute;
  color: #FFFFFF;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.9), 0 0 12px rgba(238, 147, 189, 0.8), 0 0 18px rgba(255, 255, 255, 0.6);
  animation: destelloMagico 2.4s infinite ease-in-out;
  will-change: transform, opacity;
}

/* Ubicaciones estratégicas de destellos abajo del círculo */
.p1 { top: 60%; left: 8%; font-size: 0.8rem; animation-delay: 0s; }
.p2 { top: 72%; left: 20%; font-size: 1.1rem; animation-delay: 0.4s; }
.p3 { top: 82%; left: 35%; font-size: 0.7rem; animation-delay: 0.9s; }
.p4 { top: 88%; left: 50%; font-size: 1.2rem; animation-delay: 0.2s; }
.p5 { top: 82%; left: 65%; font-size: 0.8rem; animation-delay: 0.7s; }
.p6 { top: 70%; left: 80%; font-size: 1rem; animation-delay: 1.2s; }
.p7 { top: 58%; left: 90%; font-size: 0.7rem; animation-delay: 0.5s; }
.p8 { top: 78%; left: 12%; font-size: 0.9rem; animation-delay: 1.1s; }
.p9 { top: 92%; left: 28%; font-size: 1.3rem; animation-delay: 1.5s; }
.p10 { top: 95%; left: 45%; font-size: 0.8rem; animation-delay: 0.3s; }
.p11 { top: 92%; left: 60%; font-size: 1.1rem; animation-delay: 1.7s; }
.p12 { top: 85%; left: 75%; font-size: 0.7rem; animation-delay: 0.8s; }
.p13 { top: 65%; left: 4%; font-size: 1.2rem; animation-delay: 1.3s; }
.p14 { top: 68%; left: 94%; font-size: 1rem; animation-delay: 0.1s; }
.p15 { top: 50%; left: 15%; font-size: 0.7rem; animation-delay: 1.6s; }
.p16 { top: 52%; left: 82%; font-size: 0.8rem; animation-delay: 1s; }
.p17 { top: 98%; left: 38%; font-size: 1rem; animation-delay: 0.6s; }
.p18 { top: 96%; left: 55%; font-size: 0.7rem; animation-delay: 1.4s; }

@keyframes destelloMagico {
  0%, 100% {
    opacity: 0.1;
    transform: scale(0.6) translateY(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.3) translateY(-4px);
  }
}

.quinceanera-img {
  width: 59%;
  height: auto;
  position: absolute;
  top: 58% !important;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.mono-img {
  width: 75%;
  height: auto;
  margin-top: -35%;
  position: relative;
  z-index: -3;
}

/* ==========================================
   3. TEXTOS Y CONTENIDO CENTRAL
   ========================================== */
.centered-content {
  text-align: center;
  color: #807d79;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 40px;
  z-index: 4;
  width: 90vw;
}

.lets-honor-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.99rem, 3vw, 0.99rem);
  font-weight: 600;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #9b9a99;
}

.quinceanera-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.4rem, 6vw, 1.8rem);
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #B28F60;
  margin-top: -4px;
}

.nombre-principal {
  font-family: 'ludovica', serif;
  font-size: clamp(3.2rem, 15vw, 5.2rem);
  font-weight: 500;
  line-height: 1;
  color: #5999d2;
  margin: 10px 0 0 0;
}

/* ==========================================
   4. 🎭 MÁSCARA LADO IZQUIERDO
   ========================================== */
.mascara-left-container {
  position: absolute;
  top: 45px;
  left: 10px;
  pointer-events: none;
  z-index: 5;
}

.mascara-img-left {
  width: clamp(180px, 40vw, 230px);
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
  transform: rotate(-15deg);
}

/* ==========================================
   5. 🦋 MARIPOSAS Y ANIMACIÓN
   ========================================== */
.butterflies-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 100;
  overflow: hidden;
  perspective: 1000px;
}

.mariposa-img {
  position: absolute;
  width: clamp(70px, 22vw, 110px) !important;
  height: auto;
  margin-top: 42px;
  opacity: 1 !important;
  will-change: transform;
  transform-origin: center bottom;
}

/* Keyframes de Aleteo */
@keyframes vueloSuave {
  0%, 100% {
    transform: translateY(0px) scaleX(1);
  }
  50% {
    transform: translateY(-3px) scaleX(0.75);
  }
}

.vuelo-suave {
  animation: vueloSuave 0.6s infinite ease-in-out;
}

.i-corinthia {
  font-family: 'Great Vibes', cursive;
  font-size: clamp(3.5rem, 19vw, 6.2rem);
}
</style>